<div>
<h2>System Dashboard</h2>
	<p-panel class="requestPanel shareLine panel spaceLeft" header="Report/Plot Options" toggleable="true">
		<div class="flex-container">
		<div class="flex-child requestPanel">
			<input type="radio" name="dataStart" id="startDate">Start Date
			<p-calendar [(ngModel)]="startDate" [showIcon]="true" [maxDate]="maxDate" dateFormat="mm/dd/yy" showTime="true" hourFormat="24"></p-calendar>
			<p-divider align="center"><b>OR</b></p-divider>
			<input type="radio" name="dataStart" checked id="displayPeriodOption" class="spaceLeft">Display Period
			<p-dropdown [options]="displayPeriodOptions" [(ngModel)]="selectedDisplayPeriod"></p-dropdown> <!--(onClick)="printAddOn()"-->
		</div>
		<p-divider layout="vertical">
			<b>AND</b>
		</p-divider>
		<div class="flex-child">
			End Date (required)
			<p-calendar class="spaceRight" [(ngModel)]="endDate" [showIcon]="true" [maxDate]="maxDate" dateFormat="mm/dd/yy" showTime="true" hourFormat="24">
			</p-calendar>
		</div>
		</div>
		<p-divider></p-divider>
		<!-- refresh -->
		<button pButton pRipple title="Refresh"  (click)="refreshDates()" icon="pi pi-refresh"></button>
	</p-panel>
</div>

<p-tabView>
	<p-tabPanel [header]="report.linkName" [headerStyle]="{'font-size':'larger'}"
		*ngFor="let report of systemReports; let i = index" 
		[selected]="i == 0">

			<div>
				<!-- if individual items aren't available, use the link associated with the general section -->
				<div *ngIf="report.links == null" class="ui-g-12 ui-md-3" style="text-align:center">
	                <a href={{report.link}} target="_blank">
	                	<img src={{report.image}}>
	                </a>
		        </div>
		    </div>
		
			<!-- individual links are specified, use them in an accordion -->
	    	<p-accordion #links (onOpen)="reportOpened($event, report)">	<!-- maybe try cache=true since lazy was removed-->
				<p-accordionTab *ngFor="let nsdisplay of report.links; index as i" header="{{report.linkName}} - {{nsdisplay.label}}">
					<ng-template pTemplate="content">
						<p-panel>
							<iframe width="100%" height="600" [src]="currentURL[report.linkName].fullLink | safe: 'url'"></iframe> 
						</p-panel>
					</ng-template>
				</p-accordionTab>
			</p-accordion>
	</p-tabPanel>
</p-tabView>
